export const legacyRouteRedirects = [
  {
    path: "/solutions/a200",
    to: "/equipment?model=model-docod-a200",
  },
  { path: "/ribbony", to: "/consumables-parts" },
  { path: "/ribbons", to: "/consumables-parts" },
  { path: "/consumables", to: "/consumables-parts" },
  { path: "/rashodnye-materialy", to: "/consumables-parts" },
  { path: "/rasxodnye-materialy", to: "/consumables-parts" },
  { path: "/company", to: "/about" },
  { path: "/kompaniya", to: "/about" },
  { path: "/o-kompanii", to: "/about" },
  { path: "/about-us", to: "/about" },
  { path: "/servis", to: "/service" },
  { path: "/service-and-technical-support", to: "/service" },
  { path: "/servis-i-tehnicheskaya-podderzhka", to: "/service" },
  { path: "/servis-i-tehnicheskoe-obsluzhivanie", to: "/service" },
  { path: "/termo-transfernye-printery", to: "/equipment" },
  { path: "/termotransfernye-printery", to: "/equipment" },
  { path: "/zapajshchiki", to: "/equipment" },
  { path: "/zapaishchiki", to: "/equipment" },
  { path: "/etiketirovochnoe-oborudovanie", to: "/equipment" },
  { path: "/upakovochnoe-oborudovanie", to: "/equipment" },
  { path: "/industries", to: "/solutions" },
  { path: "/industry", to: "/solutions" },
  { path: "/otrasli", to: "/solutions" },
  { path: "/otrasl", to: "/solutions" },
];

export const legacySectionRedirects = [
  "/industries/*",
  "/industry/*",
  "/otrasli/*",
  "/otrasl/*",
];
